/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import { WebpageRefFieldEdit } from "./edit-item";

// FIXME: need to copy these schema settings options to the saved field options
// const { type, title } = options || {}

const WebpageRefEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <WebpageRefFieldEdit />
        </FieldListEditWrapper>
    );
};
WebpageRefEdit.dsiplayName = "WebpageRefEdit";
export { WebpageRefEdit };
